import { useState } from "react";
import { useLocation } from "react-router-dom";
import { X, Sparkles, Hash } from "lucide-react";
import { useLang } from "@/lib/i18n";

const CONTACTS = [
  { id: "astrology", phone: "918329454656", icon: Sparkles },
  { id: "numerology", phone: "919850559397", icon: Hash },
];

const WaIcon = ({ size = 28 }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M16.04 3C9.4 3 4 8.39 4 15.02c0 2.12.55 4.19 1.6 6.02L4 29l8.17-1.57a12.04 12.04 0 0 0 3.87.63h.01C22.68 28.06 28 22.67 28 16.04 28 9.4 22.68 3 16.04 3Zm0 22.86h-.01c-1.2 0-2.38-.2-3.5-.6l-.25-.09-4.85.93.95-4.72-.16-.25a9.8 9.8 0 0 1-1.52-5.1c0-5.43 4.42-9.85 9.35-9.85 5.43 0 9.75 4.42 9.75 9.85s-4.33 9.83-9.76 9.83Zm5.4-7.36c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.05-.17-.3-.02-.46.13-.6.13-.13.3-.35.44-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.6-.92-2.2-.24-.57-.48-.5-.67-.5h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.01-1.04 2.47s1.06 2.87 1.21 3.07c.15.2 2.09 3.19 5.06 4.47.71.31 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.28.17-1.41-.07-.12-.27-.2-.57-.35Z" />
  </svg>
);

export const WhatsAppFab = () => {
  const { t } = useLang();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  if (pathname.startsWith("/admin")) return null;
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3" data-testid="whatsapp-fab">
      {open && (
        <div className="card-sacred p-3 w-72 grid gap-2 fade-up" data-testid="whatsapp-menu">
          <p className="text-xs text-slate-400 px-2 pt-1">{t("wa.title")}</p>
          {CONTACTS.map((c) => (
            <a key={c.id} href={`https://wa.me/${c.phone}?text=${encodeURIComponent(t(`wa.msg.${c.id}`))}`} target="_blank" rel="noopener noreferrer"
              className="flex items-center gap-3 px-3 py-3 rounded-xl hover:bg-[#25D366]/10 transition-colors" data-testid={`whatsapp-${c.id}`}>
              <span className="w-9 h-9 rounded-full bg-[#25D366]/15 text-[#25D366] flex items-center justify-center"><c.icon size={17} /></span>
              <span className="flex-1">
                <span className="block text-sm text-slate-100">{t(`with.${c.id}`)}</span>
                <span className="block text-xs text-slate-400 font-mono-num">+{c.phone.slice(0, 2)}-{c.phone.slice(2)}</span>
              </span>
            </a>
          ))}
        </div>
      )}
      <button onClick={() => setOpen(!open)} aria-label={t("wa.title")} data-testid="whatsapp-toggle"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.45)] flex items-center justify-center transition-transform hover:scale-105">
        {open ? <X size={26} /> : <WaIcon />}
      </button>
    </div>
  );
};
